import React from 'react';
import Preview from '~/App/Modules/Settings/MessageTemplates/Pages/Editor/Previews/Desktop';
import { PreviewProps } from '~/App/Modules/Settings/MessageTemplates/Pages/Editor/LandingPagePreview';

export function LandingPagePreview(previewProps: PreviewProps) {
  return (
    <div className='w-full h-full md:w-[825px] md:h-[600px] scale-[0.67]'>
      <Preview {...previewProps} />
    </div>
  );
}
